import { useQuery } from '@tanstack/react-query';

import {
  request,
  type V3ApiSuccessData,
  type V3ApiError,
} from 'javascripts/services/v3ApiClient';

type GetStripeClientSecretResponse = V3ApiSuccessData<{
  clientSecret: string;
}>;

export const GET_STRIPE_CLIENT_SECRET = 'GetStripeClientSecret';

export const useGetStripeClientSecret = () => {
  return useQuery<GetStripeClientSecretResponse, V3ApiError>({
    queryFn: async () => {
      const response = await request({
        url: '/accounts/payment_methods',
        method: 'post',
      });
      return response.data;
    },
    queryKey: [GET_STRIPE_CLIENT_SECRET],
  });
};
